export function urlBase64ToUint8Array(base64String: string): Uint8Array {
  const padding = '='.repeat((4 - (base64String.length % 4)) % 4)
  const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/')
  const raw = atob(base64)
  const output = new Uint8Array(raw.length)
  for (let i = 0; i < raw.length; i += 1) {
    output[i] = raw.charCodeAt(i)
  }
  return output
}

export async function getExistingPushSubscription(): Promise<PushSubscription | null> {
  if (!import.meta.client || !('serviceWorker' in navigator)) return null
  const registration = await Promise.race([
    navigator.serviceWorker.ready,
    new Promise<null>((resolve) => {
      window.setTimeout(() => resolve(null), 2500)
    }),
  ])
  if (!registration) return null
  return registration.pushManager.getSubscription()
}

export async function unsubscribeCurrentPush(
  request: (endpoint: string) => Promise<unknown>,
): Promise<void> {
  const subscription = await getExistingPushSubscription()
  if (!subscription) return
  try {
    await request(subscription.endpoint)
  } catch {
    // logout / offline should still proceed
  }
  try {
    await subscription.unsubscribe()
  } catch {
    // ignore
  }
}

